import { useSelector, useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import Highcharts from "highcharts";
import { useEffect, useState } from "react";

import Loader from "../../../../../../shared_components/Loader";
import HighchartsReact from "highcharts-react-official";

import { getTestTakenByUser } from "../../../../actions";

const QuizTestReport = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const { quizTestSubmittingLoading } = useSelector((state) => state.quizTest);

  const [loading, setLoading] = useState(true);
  const [quizTestReport, setQuizTestReport] = useState(null);


  const fetchReport = async () => {
    try {
      const response = await dispatch(getTestTakenByUser({ quizTest: id }));
      console.log("API Response:", response);

      if (response?.success && response.data) {
        setQuizTestReport(response.data.reports[0]);
      } else {
        console.error("No report data in response:", response);
      }
    } catch (error) {
      console.error("Error in fetchReport:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReport();
  }, [dispatch, id]);

  if (loading || quizTestSubmittingLoading) {
    return <Loader />;
  }

  if (!quizTestReport) {
    return (
      <div className="text-center mt-5 bg-default-2 text-white">
        <h3>No report data available</h3>
        <Link to="/quiz/tests">
          <p className="mt-3">Back to Tests</p>
        </Link>
      </div>
    );
  }

  // Extract report data
  const correctAnswers = quizTestReport?.correctAnswers || 0;
  const wrongAnswers = quizTestReport?.wrongAnswers || 0;
  const totalScore = quizTestReport?.totalScore || 0;
  const notAttemptedQuestions = quizTestReport?.responses?.filter((item) => item.selectedAnswer === undefined).length;
  const isPassed = quizTestReport?.isPassed;
  const certificateUrl = quizTestReport?.certificateUrl;

  // Highcharts Pie Chart for Correct vs Incorrect Answers
  const barChartOptions = {
    chart: {
      type: "bar",
      height: 220,
      backgroundColor: "transparent",
    },
    title: {
      text: "Correct vs Incorrect Answers",
      style: { color: "#fff" },
    },
    yAxis: {
      title: { text: "Number of Questions", style: { color: "#fff" } },
      labels: { format: "{value}", style: { color: "#fff" } },
    },
    legend: {
      itemStyle: { color: "#fff", fontWeight: "bold" }, // ✅ "Answers" in legend is white
    },
    xAxis: {
      categories: ["Correct", "Wrong", "Not Attempted"],
      labels: { style: { color: "#fff" } },
      title: {
        text: null,
      },
    },
    series: [
      {
        name: "Answers",
        data: [
          { y: correctAnswers, color: "#28a745" },
          { y: (wrongAnswers - notAttemptedQuestions), color: "#dc3545" },
          { y: notAttemptedQuestions, color: "#1524acff" }
        ],
      },
    ],
    accessibility: {
      point: {
        valueSuffix: " answers",
        style: { color: "#fff" },
      },
    },
  };

  return (
    <div className="row mx-0 my-5 d-flex flex-column justify-content-center text-center align-items-center">
      <div className="col-11 col-md-8 border rounded-3 shadow-sm p-4 text-center bg-default-2 text-white">
        <h3 className="my-3 text-white">
          🎉 Thank you for participating in the Quiz Test! 🎉
        </h3>

        <h2 className="m-0 p-0">
          <p>Your Score:</p>{" "}
          <span className="text-success fw-bold" style={{ fontSize: "60px" }}>
            {totalScore}
          </span>
        </h2>

        <h4 className="my-3">
          Result:{" "}
          <span className={`ms-1 ${isPassed ? "text-success" : "text-danger"}`}>
            {isPassed ? (
              <>
                <span className="ms-1">Passed</span>
              </>
            ) : (
              <>
                <span>Failed</span>
              </>
            )}
          </span>
        </h4>
      </div>
      <div className="col-11 col-md-8 border mt-3 rounded-3 px-0 bg-default-2 text-white">
        <HighchartsReact highcharts={Highcharts} options={barChartOptions} />
      </div>
      <div className="col-11 col-md-8 border mt-3 rounded-3 bg-default-2 text-muted">
        <p className="footer-note pt-3">
          We appreciate your effort. Keep improving!
        </p>
        <Link to="/quiz/tests">
          <p className="mt-3">Back to Tests</p>
        </Link>
      </div>
    </div>
  );
};

export default QuizTestReport;
